module.exports = __webpack_public_path__ + "static/media/diet-delivery.e63112d5.jpg";